import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isRemove === false)?_c(VDialog,{attrs:{"persistent":"","max-width":"300","scrollable":""},model:{value:(_vm.dialogModel),callback:function ($$v) {_vm.dialogModel=$$v},expression:"dialogModel"}},[_c(VCard,[_c(VCardText,{staticClass:"pa-4"},[_c('h3',[_vm._v("アップロード中")]),_c(VProgressLinear,{staticClass:"my-5",attrs:{"indeterminate":"","rounded":"","height":"6"}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }